import { removeTime } from '@/utils/date'
import { addDays } from 'date-fns'

export const acctNoRangeFrom = {
  getMessage: (field, args) => {
    return field + ' must less than or equal To Account No.'
  },
  validate: (value, args) => {
    if (value > args) {
      return false
    } else {
      return true
    }
  }
}

export const acctNoRangeTo = {
  getMessage: (field, args) => {
    return field + ' must greater than or equal From Account No.'
  },
  validate: (value, args) => {
    if (value < args) {
      return false
    } else {
      return true
    }
  }
}

export const checkDateRangeTo = {
  getMessage: (field, args) => {
    if (args.length > 0) {
      return 'Must be a later From Date'
    } else {
      return 'To Date cannot later than today'
    }
  },
  validate: (value, args) => {
    if (value) {
      if (args.length > 0) {
        return removeTime(value) >= removeTime(args)
      } else {
        return removeTime(value) >= removeTime(new Date())
      }
    } else {
      return true
    }
  }
}

export const checkDateRangeFrom = {
  getMessage: (field, args) => {
    if (args.length > 0) {
      return 'From Date cannot be later than To Date or earlier than year 2000 Account Period'
    } else {
      return 'Out of range'
    }
  },
  validate: (value, args) => {
    if (value) {
      if (args.length > 0) {
        if (removeTime(value) < removeTime(new Date(2000, 0, 1))) {
          return false
        }
        return removeTime(value) <= removeTime(args)
      } else {
        if (removeTime(value) < removeTime(new Date(2000, 0, 1))) {
          return false
        } else if (removeTime(value) > removeTime(new Date(2070, 11, 31))) {
          return false
        } else {
          return true
        }
      }
    } else {
      return true
    }
  }
}

export const checkAgeing = {
  getMessage: (field, args) => {
    var agePer = field[field.length - 1]
    var agePerInt = parseInt(agePer)
    if (agePerInt === 1) {
      return field + ' must be earlier than Current Month'
    } else {
      return field + ' must be earlier than Ageing Period ' + (agePerInt - 1)
    }
  },
  validate: (value, args) => {
    var pValue = addDays(value, 1)
    if (pValue) {
      return removeTime(pValue) <= removeTime(args)
    } else {
      return true
    }
  }
}

export const checkCurrMth = {
  getMessage: (field, args) => {
    return field + ' cannot be a future date'
  },
  validate: (value, args) => {
    if (value) {
      return removeTime(value) <= removeTime(new Date())
    } else {
      return true
    }
  }
}

export const ageByList = [
  { label: 'A - Account Period', value: 'A' },
  { label: 'T - Transaction Date', value: 'T' },
  { label: 'C - Commencement Date', value: 'C' }
]

export const stmtTypeList = [
  { label: 'O - Open Item', value: 'O' },
  { label: 'B - Balance Forward', value: 'B' }
]
